// The marathon runs past midnight: a 00:04 run belongs to the night that started the
// previous evening. Shifting 6h back makes the Rome-local calendar date the stream day.
export const STREAM_DAY_OFFSET_HOURS = 6;

// Rome-local day key of (date - 6h), as YYYY-MM-DD so keys compare lexicographically.
// Plain millisecond arithmetic, so it needs no dayjs-timezone plugin and survives DST.
export function streamDayKey(date) {
    const shifted = new Date(new Date(date).getTime() - STREAM_DAY_OFFSET_HOURS * 3600 * 1000);
    return shifted.toLocaleDateString('en-CA', { timeZone: 'Europe/Rome' });
}

// ?date=YYYY-MM-DD forces a stream day, for rehearsing a future event.
export function currentStreamDayKey() {
    return new URLSearchParams(window.location.search).get('date') || streamDayKey(new Date());
}

// Fake "now" for ?date= testing: shifts the real clock by whole calendar days so it
// lands on the requested date, keeping the real time-of-day (an override at 14:00
// stays at 14:00 on the target day, so countdowns against the schedule stay sane).
// The day strings are UTC-midnight-parsed, so the diff is an exact day count with no
// DST edge case to worry about.
export function now() {
    const override = new URLSearchParams(window.location.search).get('date');
    if (!override) return new Date();

    const todayKey = new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Rome' });
    const diffDays = Math.round((new Date(override) - new Date(todayKey)) / 86_400_000);
    return new Date(Date.now() + diffDays * 86_400_000);
}
